import { Model } from './model';

export class MachineGroupSection {
  constructor(
    public hash?: string,
    public name?: string,
    public models?: Model[],
  ) { }

  clone() {
    return new MachineGroupSection(
      this.hash,
      this.name,
      this.models,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/machine-group-section.ts